export default __webpack_public_path__ + "static/media/cri-selected.4b73a72a.svg";